import type { AccessibilityTag } from "../types/accessibility";

type SmartTagLike = Pick<AccessibilityTag, "approved_for_public"> & {
  user_roles?: { isGeneralUser?: boolean } | null;
};

/**
 * A tag the AI produced: contributed by a general user and published. Team tags are
 * recorded on site by a person, so the pair identifies AI output without a per-row
 * origin column. Mirrors the filter the accessibility lists already use.
 */
export const isSmartTag = (tag: SmartTagLike): boolean =>
  tag?.user_roles?.isGeneralUser === true && tag?.approved_for_public === true;

/**
 * True when a space carries any general-user tag. Testing "every tag" would never
 * pass: each space also holds the category-type tag ("Main entrance"), set by a person.
 */
export const isSmartTaggedSpace = (tags: SmartTagLike[] | undefined): boolean =>
  Array.isArray(tags) && tags.some(isSmartTag);
